import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, EngagementExternalRoleId, VolunteerSignupMentor } from '@interfaces';
import { AssignedStaffDialog, PersonDialog } from '../../../../../../ui/widget';
import { AssignedStaffDialogResult, EngagementEditorDialog, EngagementEditorDialogData, FollowUpEditorDialog, FollowUpEditorDialogData, MentorSignUpViewerDialog, VolunteerDialog } from '../../../../../../ui/widget/dialog';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';

export function getActions(service: VolunteeringAreaService, dialogService: DialogService) {

	const actions: GridAction<VolunteerSignupMentor>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'Open Sign-up',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(MentorSignUpViewerDialog, {
					data: {
						volunteerSignupMentorId: rows[0]!.volunteerSignupMentorId,
					}
				}, 750, 750);
				await service.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
				await service.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.person.id, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-gear',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (service.canManageVolunteerStaff()) return !!rows.length;
				return false;
			},
			execute: async rows => {
				const volunteerName = rows[0]?.person.fullName;
				const staffId = rows[0]?.assignedToStaffId || 0;
				const action = await dialogService.showCustom(AssignedStaffDialog, {
					data: {
						headerText: volunteerName!,
						staffId: staffId
					}
				}, 800, 300);

				const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
				if (result) {
					await service.updateAssignedStaffForVolunteer(rows[0]!.volunteerId, result.staffId);
					await service.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-plus',
			label: 'Add Engagement',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.ADD,
					externalRoleId: EngagementExternalRoleId.Volunteer,
					personId: rows[0]?.person.id
				};
				const dialogAction = await dialogService.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the created engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await service.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-plus',
			label: 'Add Follow-up',
			isEnabled: rows => !!rows.length,
			execute: async () => {
				const dialogData: FollowUpEditorDialogData = {
					mode: DialogMode.ADD,
					externalRoleId: EngagementExternalRoleId.Volunteer,
				};
				const dialogAction = await dialogService.showCustom(FollowUpEditorDialog, { data: dialogData }, 650, 750);

				// If save succeeds, callbackResult contains followUpId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await service.reloadData();
				}
			}
		},
	];

	return actions;
}